const PaymentStepEnum = {
    INITIATE: 'initiate',
    REVIEW: 'review',
    REVIEW_FINAL_CHARGES: 'reviewFinalCharges',
};

export default PaymentStepEnum;
